export const DEV_TEAM_MEMBERS = [
  'pautyler',
  'liaeryue',
  'thacharu',
  'apiggot',
  'ajalxis',
  'kevinvir',
  'tejasvml'
];

/**
  * Quebec sites must be defaulted to French-Canada (fr-CA).
  * See: https://t.corp.amazon.com/V1553663943/ for more details.
  */
export const CA_WAREHOUSE_FRENCH_DEFAULTS = ['YUL2'];

/**
 * Currently, safety, time and attendance, policy, quality, and positive feedback
 * are hidden from the same set of sites. These sites are identical to the sites
 * allowlisted in FCMenu. In the future, if we want to have a separate list for
 * each metric type, we can customize them in the constants below.
 */
export const PAK1_TO_PAK2_MIGRATION_PHASE_1_ALLOWLIST = [
  'ALB1',
  'AUS2',
  'BFI3',
  'BFI4',
  'BFI9',
  'BNA2',
  'CMH4',
  'EWR4',
  'GEG1',
  'GEG2',
  'JFK8',
  'KRB7',
  'LAS2',
  'MDW4',
  'MSP1',
  'OKC1',
  'PAE2',
  'ROC1',
  'SWF1',
  'SWF2',
  'SYR1',
  'TMB8',
];

// Oregon Warehouses
export const OR_WAREHOUSE_ALLOW_LIST = {
  HIO2: 'HIO2',
  PDX7: 'PDX7',
  PDX8: 'PDX8',
  PDX9: 'PDX9',
};

// Conneticut Warehouses
export const CT_WAREHOUSE_ALLOW_LIST: string[] = [
  'BDL2',
  'BDL3',
  'BDL4',
  'BDL5',
  'BDL6',
  'BDL7',
  'DBL1',
  'DBL8',
  'DCY1',
  'DCY2',
  'DCY9',
  'DEB2',
  'DOB2',
  'DOB4',
  'DOB7',
  'DYO5',
  'HBD1',
  'HFD5',
];

/**
 * Phase 1 Rollout for Quality, Safety and Feedback categories.
 */
export const PAK2_PHASE_1_ALLOWLIST = [
  "SDF9",
  "YXX2",
  "YUL2",
  "YEG2",
  "YYC4",
  "YXX1",
  "YVR6",
  "YXU1",
  "YOW3",
  "YYZ4",
  "YHM1",
  "YHM8",
  "YYZ9",
  "YVR2",
  "YVR3",
  "YVR4",
  "YYC1",
  "YEG1",
  "YOW1",
  "YOO1",
  "YHM2",
  "YYZ7",
  "YYZ1",
  "YYZ3",
  OR_WAREHOUSE_ALLOW_LIST.HIO2,
  OR_WAREHOUSE_ALLOW_LIST.PDX7,
  OR_WAREHOUSE_ALLOW_LIST.PDX8,
  OR_WAREHOUSE_ALLOW_LIST.PDX9,
];

/**
 * Phase 2 Rollout for Quality, Safety and Feedback categories.
 */
export const PAK2_PHASE_2_ALLOWLIST = [
"BFI3",
"DFW6",
"OAK3",
"SAT1",
"TPA2",
"ABQ1",
"ACY1",
"AGS1",
"AKC1",
"ATL2",
"AUS2",
"AUS3",
"BDL2",
"BDL3",
"BDL4",
"BFI4",
"BFI1",
"BHM1",
"BOI2",
"BOS3",
"BFL1",
"BWI2",
"CLE2",
"CLE3",
"HCA8",
"CMH1",
"CMH4",
"DAL3",
"DCA1",
"DEN3",
"DEN4",
"DET3",
"DET6",
"DFW7",
"DSM5",
"DTW1",
"ELP1",
"EWR4",
"EWR9",
"FAT1",
"FSD1",
"FTW6",
"FWA6",
"GEG1",
"GRR1",
"DEN9",
"MKE3",
"GYR1",
"HOU2",
"HOU6",
"IGQ1",
"JAN1",
"JAX2",
"JFK8",
"LAS7",
"OAK8",
"SHV1",
"LGA9",
"LGB3",
"LGB7",
"LIT1",
"LUK2",
"MCO1",
"MDW7",
"MEM4",
"MIA1",
"MKC6",
"MKE1",
"MKE2",
"MLI1",
"MQY1",
"MSP1",
"MTN1",
"OAK4",
"OKC1",
"OMA2",
"ORD5",
"ORF3",
"OXR1",
"PAE2",
"PCW1",
"PSP1",
"RDU1",
"RIC4",
"ROC1",
"SAN3",
"FTY1",
"LGA6",
"SAT2",
"SAT3",
"SAV4",
"SBD6",
"SCK6",
"SLC1",
"SMF1",
"STL8",
"SYR1",
"TLH2",
"TPA1",
"TPA4",
"TUL2",
"TUS2",
"TYS1",
"VGT1",
"SEA6",
"PVD2",
"ORH3",
"AGS2",
"MGE7",
"IAH1",
"FTW4",
"ABE3",
"AFW1",
"CSG1",
"DAL2",
"FTW3",
"IND4",
"MDT2",
"MGE1",
"ONT6",
"RDG1",
"SDF1",
"KRB5",
"MDW4",
"FTW9",
"ABE2",
"PHL7",
"RIC2",
"BNA3",
"IND1",
"IND3",
"SDF4",
"SDF8",
"CAE1",
"BFL2",
"ONT2",
"PHX3",
"PHX6",
"BFI9",
"MEM2",
"DMO8",
"CMH7",
"BWI1",
"LAS8",
"FTW7",
"MCO3",
"ORD4",
"LEX3",
"CAE3",
"YYZ8",
"PHL9",
"BDL7",
"CLE7",
];

/**
 * Phase 3 Rollout for Quality, Safety and Feedback categories.
 */
export const PAK2_PHASE_3_ALLOWLIST = [
  "ABE8",
  "AVP1",
  "CLT2",
  "FTW1",
  "FWA4",
  "GEU2",
  "GEU3",
  "GEU5",
  "GYR2",
  "HGR6",
  "HIA1",
  "HLI2",
  "IAH3",
  "IND9",
  "LAS1",
  "LAX9",
  "LGB8",
  "MDW2",
  "MEM1",
  "MIT2",
  "MQJ1",
  "ONT8",
  "ORF2",
  "POC1",
  "POC2",
  "POC3",
  "QXY8",
  "RDU2",
  "RYY2",
  "SBD1",
  "SCK4",
  "SMF3",
  "SWF2",
  "TEB9",
  "VGT2",
  "BJC1",
  "XLX6",
  "XEW2",
  "MQJ3",
  "MCC1",
  "PSP3",
  "GYR3",
  "RFD2",
  "PIL1",
  "ABE4",
  "ACY2",
  "AKR1",
  "ALB1",
  "AMA1",
  "BNA2",
  "BOS7",
  "BWI4",
  "CHA2",
  "CHO1",
  "CLT3",
  "DED2",
  "CMH3",
  "DCA6",
  "DEN2",
  "DEN8",
  "DET1",
  "DET2",
  "FAT2",
  "FOE1",
  "FTW5",
  "GEG2",
  "GSO1",
  "GSP1",
  "HOU8",
  "HSV1",
  "ICT2",
  "IGQ2",
  "ILG1",
  "IND2",
  "IND5",
  "JAX3",
  "JVL1",
  "LAS6",
  "LFT1",
  "LGB4",
  "LGB6",
  "LIT2",
  "MCE1",
  "MCO2",
  "MDT1",
  "PBI3",
  "MDT4",
  "MDW6",
  "MDW9",
  "MEM6",
  "RDU4",
  "MGE3",
  "MKC4",
  "SAN6",
  "OKC2",
  "ONT9",
  "ORD2",
  "PHL4",
  "PHL5",
  "PHL6",
  "PHX5",
  "PHX7",
  "PIT2",
  "RIC1",
  "RNO4",
  "SAT4",
  "SAV3",
  "SBD2",
  "SCK1",
  "SJC7",
  "SLC2",
  "SMF6",
  "SNA4",
  "STL3",
  "STL4",
  "SWF1",
  "TEB3",
  "TEB4",
  "TEB6",
  "TPA3",
  "LAN2",
  "LAL2",
  "ABQ2",
  "CMH2",
];

/**
 * Phase 3 Rollout for Quality, Safety and Feedback categories.
 */
export const PAK2_PHASE_4_ALLOWLIST = [
  "LAS2",
  "LEX1",
  "TEN1",
  "PCA1",
  "EWR7",
  "PGA1",
  "TUS1",
  "CHA1",
  "MEM3",
  "MCI7",
  "FAR1",
  "SDF6",
  "DPA7",
  "HOU3",
  "LUK7",
  "IND8",
  "LEX2",
  "CVG2",
  "KRB3",
  "PHX9",
  "KRB9",
  "FTW7",
  "FTW8",
  "KRB6",
  "RFD3",
  "ATL7",
  "SAV7",
  "JAX7",
  "AVP8",
  "PPA2",
  "WBW2",
  "MDT9",
  "HGR5",
  "KRB2",
];

export const PAK2_PHASE_5_ALLOWLIST = [
  'BJX1',
  'GDL1',
  'GDL2',
  'HMO3',
  'MEX1',
  'MEX2',
  'MEX3',
  'MEX6',
  'MID1',
  'MTY1',
  'MTY2',
  'TIJ1',
];

// Adding remaining CT sites not previously onboarded
export const PAK2_PHASE_6_ALLOWLIST = [
  'BDL5',
  'BDL6',
  'DBL1',
  'DBL8',
  'DCY1',
  'DCY2',
  'DCY9',
  'DEB2',
  'DOB2',
  'DOB4',
  'DOB7',
  'DYO5',
  'HBD1',
  'HFD5',
];

export const WA_WAREHOUSE_ALLOW_LIST: string[] = [
  'BFI1',
  'BFI3',
  'BFI4',
  'BFI9',
  'GEG1',
  'GEG2',
  'PAE2',
  'AUN2',
  'HWA4',
  'PSC2',
  'AFE1',
  'AFE2',
  'QYY6',
];

// CT sites to be enabled for Prod/Quality email report
export const CT_WAREHOUSE_SPPR_SQPR_REPORTING_LIST: string[] = [
  'BDL2',
  'BDL3',
  'BDL4',
  'BDL7',
];

// CT sites to be enabled for Idle time email report
export const CT_WAREHOUSE_IDLE_TIME_REPORTING_LIST: string[] = [
  "BDL2",
  "BDL3",
  "BDL4",
  "BDL7",
  'BDL5',
  'BDL6',
  'DBL1',
  'DBL8',
  'DCY1',
  'DCY2',
  'DCY9',
  'DEB2',
  'DOB2',
  'DOB4',
  'DOB7',
  'DYO5',
  'HBD1',
  'HFD5',
];

/* Phased rollout dates can be found here:
 * https://quip-amazon.com/ozWIAc8XagpU/SPPR-Rollout-POCs#temp:C:LZW85b6468cf45d4089b0ca71854
*/
export const phase1Date = '2024/10/23';
const phase2Date = '2024/11/06';
const phase3Date = '2024/11/13';
const phase4Date = '2024/11/20';
const phase5Date = '2025/02/06';
const phase6Date = '2026/06/15';

const phasedReleaseAllowlist = () => {
  const today = new Date();

  const phase1 = new Date(phase1Date);
  const phase2 = new Date(phase2Date);
  const phase3 = new Date(phase3Date);
  const phase4 = new Date(phase4Date);
  const phase5 = new Date(phase5Date);
  const phase6 = new Date(phase6Date);
  const allowlist = [];

  if (today >= phase1) allowlist.push(...PAK2_PHASE_1_ALLOWLIST);
  if (today >= phase2) allowlist.push(...PAK2_PHASE_2_ALLOWLIST);
  if (today >= phase3) allowlist.push(...PAK2_PHASE_3_ALLOWLIST);
  if (today >= phase4) allowlist.push(...PAK2_PHASE_4_ALLOWLIST);
  if (today >= phase5) allowlist.push(...PAK2_PHASE_5_ALLOWLIST);
  if (today >= phase6) allowlist.push(...PAK2_PHASE_6_ALLOWLIST);

  return allowlist;
};

/**
 * The Request Help feature is no longer intended to be used in PAK 2.0
 * now that help can be requested in MyPerformance.
 */
export const REQUEST_HELP_WAREHOUSE_ALLOW_LIST: string[] = [];

/**
 * Allow list for showing productivity/quality workspeed data
 * https://quip-amazon.com/9Wc3AW048TnT/PC-PAK20-MN-bill-requirements
 * https://quip-amazon.com/OBcVAomBzFUm/PC-PAK20-WA-bill-requirements
 */
export const REPORTING_WAREHOUSE_ALLOW_LIST: string[] = [
  'MSP1',
  'APC2',
  ...WA_WAREHOUSE_ALLOW_LIST,
  ...CT_WAREHOUSE_SPPR_SQPR_REPORTING_LIST,
  ...Object.values(OR_WAREHOUSE_ALLOW_LIST),
];

/**
 * Allow list for showing idle Time/productive Time data.
 * https://quip-amazon.com/9Wc3AW048TnT/PC-PAK20-MN-bill-requirements
 */
export const IDLE_TIME_WAREHOUSE_ALLOW_LIST: string[] = [
  'MSP1',
  'APC2',
  ...WA_WAREHOUSE_ALLOW_LIST,
  ...CT_WAREHOUSE_IDLE_TIME_REPORTING_LIST,
];

// Users to display mock data to for demo purposes
export const MOCK_DATA_EMPLOYEE_IDS = [
  '101575923', // pautyler
  '104706990', // liaeryue
  '107256890', // thacharu
  '105560665', // ajalxis
  '103188758', // apiggot
  '205483136', // tejasvml
];

